// 本地离线图标，启动时在 main.ts 中加载，避免运行时请求 iconify CDN
import { addIcon } from '@iconify/vue/dist/offline'
import { getSvgInfo } from '@pureadmin/utils'
import CryptocurrencyColorUsdt from '~icons/cryptocurrency-color/usdt?raw'
import EpArrowDown from '~icons/ep/arrow-down?raw'
import EpArrowLeft from '~icons/ep/arrow-left?raw'
import EpBack from '~icons/ep/back?raw'
import EpCaretBottom from '~icons/ep/caret-bottom?raw'
import EpCheck from '~icons/ep/check?raw'
import EpChecked from '~icons/ep/checked?raw'
import EpClose from '~icons/ep/close?raw'
import EpCloudy from '~icons/ep/cloudy?raw'
import EpCopyDocument from '~icons/ep/copy-document?raw'
import EpEdit from '~icons/ep/edit?raw'
import EpExpand from '~icons/ep/expand?raw'
import EpGuide from '~icons/ep/guide?raw'
import EpHistogram from '~icons/ep/histogram?raw'
import EpHomeFilled from '~icons/ep/home-filled?raw'
import EpLoading from '~icons/ep/loading?raw'
import EpLollipop from '~icons/ep/lollipop?raw'
import EpMenu from '~icons/ep/menu?raw'
import EpMonitor from '~icons/ep/monitor?raw'
import EpRefresh from '~icons/ep/refresh?raw'
import EpSetUp from '~icons/ep/set-up?raw'
import EpShoppingCart from '~icons/ep/shopping-cart?raw'
import EpSuccessFilled from '~icons/ep/success-filled?raw'
import EpSwitchButton from '~icons/ep/switch-button?raw'
import EpTickets from '~icons/ep/tickets?raw'
import EpUser from '~icons/ep/user?raw'
import EpUserFilled from '~icons/ep/user-filled?raw'
import EpWallet from '~icons/ep/wallet?raw'
import EpList from '~icons/ep/list?raw'
import EpCoin from '~icons/ep/coin?raw'
import EpMedal from '~icons/ep/medal?raw'
import EpPostcard from '~icons/ep/postcard?raw'
import FaSolidCoins from '~icons/fa-solid/coins?raw'
import FaSolidPowerOff from '~icons/fa-solid/power-off?raw'
import MdiEye from '~icons/mdi/eye?raw'
import RiAccountBoxLine from '~icons/ri/account-box-line?raw'
import RiAddCircleLine from '~icons/ri/add-circle-line?raw'
import RiAdminFill from '~icons/ri/admin-fill?raw'
import RiAdminLine from '~icons/ri/admin-line?raw'
import RiAlipayFill from '~icons/ri/alipay-fill?raw'
import RiArtboardLine from '~icons/ri/artboard-line?raw'
import RiAttachment2 from '~icons/ri/attachment-2?raw'
import RiBankCardFill from '~icons/ri/bank-card-fill?raw'
import RiBankCardLine from '~icons/ri/bank-card-line?raw'
import RiBankFill from '~icons/ri/bank-fill?raw'
import RiBarChart2Line from '~icons/ri/bar-chart-2-line?raw'
import RiBarChartHorizontalLine from '~icons/ri/bar-chart-horizontal-line?raw'
import RiBookmark2Line from '~icons/ri/bookmark-2-line?raw'
import RiChatSearchLine from '~icons/ri/chat-search-line?raw'
import RiCheckboxCircleLine from '~icons/ri/checkbox-circle-line?raw'
import RiCodeBoxLine from '~icons/ri/code-box-line?raw'
import RiComputerLine from '~icons/ri/computer-line?raw'
import RiEditBoxLine from '~icons/ri/edit-box-line?raw'
import RiFileExcelLine from '~icons/ri/file-excel-line?raw'
import RiFileInfoLine from '~icons/ri/file-info-line?raw'
import RiFileLine from '~icons/ri/file-line?raw'
import RiFileList3Line from '~icons/ri/file-list-3-line?raw'
import RiFilePdfLine from '~icons/ri/file-pdf-line?raw'
import RiFilePpt2Line from '~icons/ri/file-ppt-2-line?raw'
import RiFilePptLine from '~icons/ri/file-ppt-line?raw'
import RiFileSearchLine from '~icons/ri/file-search-line?raw'
import RiFileWordLine from '~icons/ri/file-word-line?raw'
import RiFileZipLine from '~icons/ri/file-zip-line?raw'
import RiFolderHistoryLine from '~icons/ri/folder-history-line?raw'
import RiGitBranchLine from '~icons/ri/git-branch-line?raw'
import RiHistoryFill from '~icons/ri/history-fill?raw'
import RiImageLine from '~icons/ri/image-line?raw'
import RiInformationLine from '~icons/ri/information-line?raw'
import RiInstallLine from '~icons/ri/install-line?raw'
import RiLinksFill from '~icons/ri/links-fill?raw'
import RiListCheck from '~icons/ri/list-check?raw'
import RiMarkdownLine from '~icons/ri/markdown-line?raw'
import RiMindMap from '~icons/ri/mind-map?raw'
import RiPlayCircleLine from '~icons/ri/play-circle-line?raw'
import RiSearchEyeLine from '~icons/ri/search-eye-line?raw'
import RiSearchLine from '~icons/ri/search-line?raw'
import RiSendPlaneFill from '~icons/ri/send-plane-fill?raw'
import RiSettings3Line from '~icons/ri/settings-3-line?raw'
import RiShieldUserFill from '~icons/ri/shield-user-fill?raw'
import RiTableLine from '~icons/ri/table-line?raw'
import RiTerminalWindowLine from '~icons/ri/terminal-window-line?raw'
import RiUbuntuFill from '~icons/ri/ubuntu-fill?raw'
import RiUserVoiceLine from '~icons/ri/user-voice-line?raw'
import RiWechatPayFill from '~icons/ri/wechat-pay-fill?raw'
import RiWindowLine from '~icons/ri/window-line?raw'

const icons = [
	['cryptocurrency-color/usdt', CryptocurrencyColorUsdt],
	['ep/arrow-down', EpArrowDown],
	['ep/arrow-left', EpArrowLeft],
	['ep/back', EpBack],
	['ep/caret-bottom', EpCaretBottom],
	['ep/check', EpCheck],
	['ep/checked', EpChecked],
	['ep/close', EpClose],
	['ep/cloudy', EpCloudy],
	['ep/copy-document', EpCopyDocument],
	['ep/edit', EpEdit],
	['ep/expand', EpExpand],
	['ep/guide', EpGuide],
	['ep/histogram', EpHistogram],
	['ep/home-filled', EpHomeFilled],
	['ep/loading', EpLoading],
	['ep/lollipop', EpLollipop],
	['ep/menu', EpMenu],
	['ep/monitor', EpMonitor],
	['ep/refresh', EpRefresh],
	['ep/set-up', EpSetUp],
	['ep/shopping-cart', EpShoppingCart],
	['ep/success-filled', EpSuccessFilled],
	['ep/switch-button', EpSwitchButton],
	['ep/tickets', EpTickets],
	['ep/user', EpUser],
	['ep/user-filled', EpUserFilled],
	['ep/wallet', EpWallet],
	['ep/list', EpList],
	['ep/coin', EpCoin],
	['ep/medal', EpMedal],
	['ep/postcard', EpPostcard],
	['fa-solid/coins', FaSolidCoins],
	['fa-solid/power-off', FaSolidPowerOff],
	['mdi/eye', MdiEye],
	['ri/account-box-line', RiAccountBoxLine],
	['ri/add-circle-line', RiAddCircleLine],
	['ri/admin-fill', RiAdminFill],
	['ri/admin-line', RiAdminLine],
	['ri/alipay-fill', RiAlipayFill],
	['ri/artboard-line', RiArtboardLine],
	['ri/attachment-2', RiAttachment2],
	['ri/bank-card-fill', RiBankCardFill],
	['ri/bank-card-line', RiBankCardLine],
	['ri/bank-fill', RiBankFill],
	['ri/bar-chart-2-line', RiBarChart2Line],
	['ri/bar-chart-horizontal-line', RiBarChartHorizontalLine],
	['ri/bookmark-2-line', RiBookmark2Line],
	['ri/chat-search-line', RiChatSearchLine],
	['ri/checkbox-circle-line', RiCheckboxCircleLine],
	['ri/code-box-line', RiCodeBoxLine],
	['ri/computer-line', RiComputerLine],
	['ri/edit-box-line', RiEditBoxLine],
	['ri/file-excel-line', RiFileExcelLine],
	['ri/file-info-line', RiFileInfoLine],
	['ri/file-line', RiFileLine],
	['ri/file-list-3-line', RiFileList3Line],
	['ri/file-pdf-line', RiFilePdfLine],
	['ri/file-ppt-2-line', RiFilePpt2Line],
	['ri/file-ppt-line', RiFilePptLine],
	['ri/file-search-line', RiFileSearchLine],
	['ri/file-word-line', RiFileWordLine],
	['ri/file-zip-line', RiFileZipLine],
	['ri/folder-history-line', RiFolderHistoryLine],
	['ri/git-branch-line', RiGitBranchLine],
	['ri/history-fill', RiHistoryFill],
	['ri/image-line', RiImageLine],
	['ri/information-line', RiInformationLine],
	['ri/install-line', RiInstallLine],
	['ri/links-fill', RiLinksFill],
	['ri/list-check', RiListCheck],
	['ri/markdown-line', RiMarkdownLine],
	['ri/mind-map', RiMindMap],
	['ri/play-circle-line', RiPlayCircleLine],
	['ri/search-eye-line', RiSearchEyeLine],
	['ri/search-line', RiSearchLine],
	['ri/send-plane-fill', RiSendPlaneFill],
	['ri/settings-3-line', RiSettings3Line],
	['ri/shield-user-fill', RiShieldUserFill],
	['ri/table-line', RiTableLine],
	['ri/terminal-window-line', RiTerminalWindowLine],
	['ri/ubuntu-fill', RiUbuntuFill],
	['ri/user-voice-line', RiUserVoiceLine],
	['ri/wechat-pay-fill', RiWechatPayFill],
	['ri/window-line', RiWindowLine],
]

icons.forEach(([name, icon]) => {
	addIcon(name as string, getSvgInfo(icon as string))
})
